
    import { defineComponent } from 'vue'
    import {useRouter} from "vue-router";

    export default defineComponent({
        name: "ensureService",
        setup() {
            // 获取路由器实例
            const router = useRouter();
            return {
                router
            }
        },
        methods: {
            toView(){
                this.router.push({
                    path: '/idlefishExplain',
                })
            }
        },
    })
